import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { fmtDate } from "../lib/roles";
import { Empty, Loading, PageHeader, Panel } from "../components/common";

export default function ReportDetail() {
  const { id } = useParams();
  const [r, setR] = useState(undefined);
  useEffect(() => { api(`/reports/${id}`).then((d) => setR(d.report)).catch(() => setR(null)); }, [id]);
  if (r === undefined) return <Loading />;
  if (!r) return <Empty title="Report non trovato." />;
  return (
    <div className="max-w-3xl">
      <PageHeader subtitle={r.tipo} title={r.titolo} />
      <Panel data-testid="report-detail">
        <p className="whitespace-pre-wrap leading-relaxed">{r.contenuto}</p>
        <p className="text-xs text-slate-400 mt-6">Inviato da {r.author_name} · {r.mansione} · {fmtDate(r.created_at, true)}</p>
      </Panel>
    </div>
  );
}
